// let optionKey ={};
// updates the UI post login/token acquisition
export const updateUI = () =>
{
    let join_col = document.getElementById('join_col');
    join_col.classList.add('d-none');
    join_col.style.cssText = 'display:none !important';
    document.getElementById('profile').classList.remove('d-none');
}
